import { CircularProgress, Grid, Typography, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import { APIHeader } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  ListFilterTableGrid,
  TrackingInfoDrivers,
  homeButtonComponent,
  titleName,
  pageGrid,
  modernContentSection,
} from '../../styles';
import { stripTrailingSlash } from '../../utils';
import UMTable from '../UserManagement/UMTable';
import LeftPanel from './LeftPanel';
import PageHeader from '../../components/shared/PageHeader';

//Department Management page. Showing on UI but this page is of no use as of now
const DepartmentManagement = props => {
  const { apiConfig, userInfo, errorInAPI } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const filterId = stripTrailingSlash(window.location.toString())
    .split('/')
    .pop();

  const [isLoading, setIsLoading] = useState(true);
  const [showTable, setShowTable] = useState(true);
  const [userDepartmentList, setUserDepartmentList] = useState([]);
  const [siteListData, setSiteListData] = useState([]);
  const [departmentListData, setDepartmentListData] = useState([]);
  const [departmenDetails, setDepartmenDetails] = useState({
    SortBy: 'UserId',
    OrderBy: 'desc',
    filterDepartment: '',
    filterSites: '',
  });
  const [searchString, setSearchString] = useState('');

  useEffect(() => {
    //Get the site list
    fetch(`${apiConfig.uiURL}api/SiteList`, {
      headers: APIHeader(),
    })
      .then(async response => {
        const siteData = await response.json();
        setSiteListData(siteData);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    //Get the department list
    fetch(`${apiConfig.uiURL}api/FetchPECRDepartments`, {
      headers: APIHeader(),
    })
      .then(async response => {
        const departmentData = await response.json();
        setDepartmentListData(departmentData);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiConfig]);

  //useEffect is getting exceuted for default page
  useEffect(() => {
    if (filterId === 'DM') {
      setIsLoading(true);
      //fetch list to show by default
      fetch(`${apiConfig.uiURL}api/FetchDepartmentManagementDetails`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          search: '',
          sort: '',
          ascdesc: '',
          filterDepartment: '',
          filterSites: '',
        }),
      })
        .then(async response => {
          const data = await response.json();
          setUserDepartmentList(data);
          setIsLoading(false);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiConfig, filterId]);

  //To handle the sorting of columns in table grid
  const handleOrderChange = (columnId, order) => {
    setShowTable(false);
    setDepartmenDetails({
      ...departmenDetails,
      SortBy: columnId,
      OrderBy: order,
    });
    // Get the List of DM details based on sorted column and order
    fetch(`${apiConfig.uiURL}api/FetchDepartmentManagementDetails`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        search: searchString,
        sort: columnId,
        ascdesc: order,
        filterDepartment: departmenDetails.filterDepartment,
        filterSites: departmenDetails.filterSites,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setUserDepartmentList(data);
        setShowTable(true);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To handle the onChange event of search box
  const handleSearchChange = event => {
    setShowTable(false);
    const searchText = event.target.value.trim();
    setSearchString(searchText);
    // Get the List of DM details based on search
    fetch(`${apiConfig.uiURL}api/FetchDepartmentManagementDetails`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        search: searchText,
        sort: departmenDetails.SortBy,
        ascdesc: departmenDetails.OrderBy,
        filterDepartment: departmenDetails.filterDepartment,
        filterSites: departmenDetails.filterSites,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setUserDepartmentList(data);
        setShowTable(true);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  const onRefreshClick = dropdownValue => {
    console.log('dropdownValue', dropdownValue);
  };
  if (errorInAPI.hasErrorOccured) {
    return <ErrorAlert message={errorInAPI.message} />;
  }

  if ((userInfo && userInfo.userId === '') || isLoading) {
    return (
      <Grid style={homeButtonComponent}>
        <CircularProgress />
      </Grid>
    );
  }

  if (
    userInfo &&
    userInfo?.role !== 'Site Administrator' &&
    userInfo?.role !== 'System Administrator'
    // ******* DELETE THIS, ONLY HERE FOR TESTINGG*****
    // userInfo?.role !== "Site Coordinator"
  ) {
    return (
      <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
    );
  }
  if (
    (userInfo && userInfo?.active?.toString() === '0') ||
    userInfo?.userId.toString() === '0' ||
    userInfo?.userId === null
  ) {
    return (
      <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
    );
  }
  return (
    <div className="flex flex-col">
      <PageHeader title={t('Department_Management')}></PageHeader>

      <Box style={modernContentSection}>
        <Grid style={ListFilterTableGrid}>
          <LeftPanel
            onRefreshClick={onRefreshClick}
            handleSearchChange={handleSearchChange}
            siteListData={siteListData}
            departmentListData={departmentListData}
          />
          {userDepartmentList.length > 0 ? (
            <Grid>
              <UMTable
                rows={userDepartmentList}
                orderHandler={handleOrderChange}
                OrderSortBy={departmenDetails}
                showTable={showTable}
              />
            </Grid>
          ) : (
            <Grid style={homeButtonComponent}>
              <Typography style={{ padding: '10px', fontWeight: 'bold' }}>
                {t('No_result_found')}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(DepartmentManagement);
